module.exports = __webpack_public_path__ + "1011004ae218748c842a0154bb110dd0.png";